module.exports = __webpack_public_path__ + "images/logopaybay.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/logopaybay.png
// module id = 377
// module chunks = 2